/**
 * Welcome popup: auto-opens on every storefront page, at most once per day per device.
 * Relies on the modal-dialog custom element from global.js (deferred, so wait for its definition).
 */
(function () {
  var STORAGE_KEY = 'crave:welcome-popup:last-shown';

  function todayKey() {
    var d = new Date();
    return (
      d.getFullYear() +
      '-' +
      String(d.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getDate()).padStart(2, '0')
    );
  }

  function init() {
    var modal = document.querySelector('#WelcomePopupModal');
    if (!modal) return;

    // Don't auto-open inside the theme editor, so it never interferes with editing
    if (window.Shopify && window.Shopify.designMode) return;

    var lastShown = null;
    try {
      lastShown = window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      // localStorage unavailable (e.g. private mode) — still show the popup
    }
    if (lastShown === todayKey()) return;

    var timer = null;
    function clearTimer() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    }

    // Other modals on the page (product popups, etc.) also dispatch modalClosed,
    // so only clear the timer when OUR popup has actually closed
    document.body.addEventListener('modalClosed', function () {
      if (!modal.hasAttribute('open')) clearTimer();
    });

    // Write today's date when showing: users who never close it still count as having seen it
    modal.show();
    try {
      window.localStorage.setItem(STORAGE_KEY, todayKey());
    } catch (error) {
      // Write failed — it will show again next visit, acceptable
    }

    var duration = parseInt(modal.dataset.duration, 10) || 15;
    timer = setTimeout(function () {
      timer = null;
      modal.hide();
    }, duration * 1000);
  }

  // Section scripts run during parsing, before the deferred global.js registers modal-dialog
  customElements.whenDefined('modal-dialog').then(init);
})();
